import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function LegalNotice() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-warm-sand">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6 text-[#005F73]" data-testid="btn-back">
          <ArrowLeft className="w-4 h-4 mr-2" /> Retour
        </Button>

        <h1 className="text-3xl sm:text-4xl font-semibold text-[#005F73] mb-8">Mentions légales</h1>

        <div className="space-y-8 text-stone-700 leading-relaxed text-sm sm:text-base">
          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">Éditeur du site</h2>
            <p>
              Le site <strong>gwadimmo-invest.com</strong> est édité par GwadImmo Invest.<br />
              Email de contact : <a href="mailto:gwadimmo.invest@gmail.com" className="text-[#0A9396] underline">gwadimmo.invest@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">Hébergement</h2>
            <p>Le site est hébergé par Emergent SH.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">Propriété intellectuelle</h2>
            <p>
              L'ensemble des contenus présents sur le site gwadimmo-invest.com (textes, images, graphismes, logo, icônes, logiciels, etc.) est protégé par les lois en vigueur sur la propriété intellectuelle. Toute reproduction, représentation, modification ou exploitation non autorisée est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">Responsabilité</h2>
            <p>
              Les informations et calculs fournis par GwadImmo Invest sont donnés à titre indicatif et ne constituent en aucun cas un conseil en investissement. L'utilisateur est seul responsable de ses décisions d'investissement. GwadImmo Invest ne saurait être tenu responsable de toute perte ou dommage résultant de l'utilisation des informations fournies par le site.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">Données personnelles</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Pour exercer ces droits, contactez-nous à l'adresse : <a href="mailto:gwadimmo.invest@gmail.com" className="text-[#0A9396] underline">gwadimmo.invest@gmail.com</a>.
            </p>
            <p className="mt-2">
              Pour en savoir plus, consultez notre <a href="/privacy" className="text-[#0A9396] underline cursor-pointer" onClick={(e) => { e.preventDefault(); navigate('/privacy'); }}>Politique de confidentialité</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#005F73] mb-3">Cookies</h2>
            <p>
              Le site utilise des cookies techniques strictement nécessaires au fonctionnement du service (authentification, session). Aucun cookie publicitaire ou de suivi n'est utilisé.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
